import { get, has } from 'lodash'

import { formValidator } from '../../service/util.service'
import FormConfig from 'FormConfig'
import FormValidation from 'FormValidation'
import { useTranslate } from './index'
import { FormFieldV2 } from '../../types/interface/form.interface'
import { getFlowName, getProductName } from '@dg-util'

const useFormConfig = (formId: string, validationArgs?: Record<string, unknown>) => {
  const { t } = useTranslate(formId)
  const flowName = getFlowName()
  const productName = getProductName()
  const config = get(FormConfig, [flowName, formId, productName])
  const validation = get(FormValidation, [flowName, formId, productName])

  const configFields = get(config, ['fields']) as Record<string, FormFieldV2>

  // Copy rather than assign onto the config. `FormConfig` is a module singleton shared by
  // every form instance, so writing translated strings onto it made rendering a mutation
  // of global state — two FormBuilders for the same form id (the mobile and desktop trees
  // render one each) both wrote to the same objects.
  const fields =
    configFields &&
    (Object.fromEntries(
      Object.entries(configFields).map(([fieldKey, field]) => [
        fieldKey,
        {
          ...field,
          ...(field.customLabel ? {} : { label: t(`form.${fieldKey}.label`) }),
          ...(has(field, ['componentProps', 'defaultItemText'])
            ? {
                componentProps: {
                  ...field.componentProps,
                  defaultItemText: t(`form.${fieldKey}.defaultItem`),
                },
              }
            : {}),
          placeholder: t(`form.${fieldKey}.placeholder`),
          errorMsg: t(`form.${fieldKey}.error`),
        },
      ])
    ) as Record<string, FormFieldV2>)

  return {
    fields,
    initialStaticValues: get(FormConfig, [flowName, formId, productName, 'initialValues']),
    validation: formValidator(validationArgs ? validation(validationArgs) : validation),
  }
}

export default useFormConfig
